var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Subtraction 48",
  d: "M23.006 32c-.144 0-14.408-.011-17.937-.967A5.782 5.782 0 0 1 1 26.989 44.2 44.2 0 0 1 .006 16.11 74 74 0 0 1 .969 5.041 5.784 5.784 0 0 1 5.039 1C8.557.044 22.832 0 22.975 0s14.41.012 17.939.966a5.789 5.789 0 0 1 4.07 4.045c1.524 6.095 1.166 15.67.029 21.979a5.779 5.779 0 0 1-4.072 4.044c-3.529.955-17.791.966-17.935.966ZM18.4 9.143v13.714L30.321 16 18.4 9.143Z",
  fill: "#fff"
})));
export default SvgYoutube;